/*
* Super secret stuff
*/

const TWITCH_API_KEY = 'rqob3rnv2tlfmjw9dnha9jpoomjeof';

const GOOGLE_URL_SHORTENER_API_KEY = 'AIzaSyD3Qk2jf8Sca36gfmUgp-zxp7yqV2rdmaU';

export {
  TWITCH_API_KEY,
  GOOGLE_URL_SHORTENER_API_KEY
};



// WEBPACK FOOTER //
// ./src/secrets.js